import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import Nav from "./Nav.jsx";
import Footer from "./Footer.jsx";
import "./home.css";
import "./Sales.css";
import StandardPageMain from "../Components/StandardCardMain.jsx";
import ErrorMessage from "../Components/ErrorPopup.jsx";
import useFetch from "../Components/UseFetch.jsx";
import { parseApiError } from "../HelperFx/common.js";
import {
  bMEDisposalRequests,
  companyDefault,
} from "../HelperFx/datalinks.js";
import verifyToken from "../HelperFx/verifyJwt.js";

const REACT_DATA_URL = process.env.REACT_APP_API_DATA_URL;
const REACT_UNAME = process.env.REACT_APP_API_USERNAME;
const REACT_PWD = process.env.REACT_APP_API_PASSWORD;
const DISPOSAL_TABLE_ID = 50535;

const toDateInput = (value) => {
  if (!value) return "";
  const text = String(value);
  if (text.includes("0001-01-01") || text.startsWith("0001-")) return "";
  return text.slice(0, 10);
};

const mapHeader = (record) => ({
  ...record,
  requestDate: toDateInput(record.requestDate),
});

const DisposalRequest = () => {
  const location = useLocation();
  const token = btoa(`${REACT_UNAME}:${REACT_PWD}`);
  const docNo = location.state?.number || "";
  const { custName } = verifyToken(sessionStorage.getItem("authToken")) || {};
  const [header, setHeader] = useState({});
  const [errorOpen, setErrorOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const headerUrl = docNo
    ? `${REACT_DATA_URL}${bMEDisposalRequests}?${companyDefault}&$filter=no eq '${docNo}'${
        custName ? ` and customerNo eq '${custName}'` : ""
      }`
    : null;
  const { data: headerResponse } = useFetch(
    headerUrl ||
      `${REACT_DATA_URL}${bMEDisposalRequests}?${companyDefault}&$top=0`,
    token,
  );

  useEffect(() => {
    const record = headerResponse?.value?.[0];
    if (record) setHeader(mapHeader(record));
  }, [headerResponse]);

  const handlePageBlur = async (field, value, formData) => {
    if (header[field] === value) return;
    if (!header.systemId) return;

    try {
      const response = await axios.patch(
        `${REACT_DATA_URL}${bMEDisposalRequests}(${header.systemId})?${companyDefault}`,
        { [field]: value },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Basic ${token}`,
            "If-Match": "*",
          },
        },
      );
      setHeader(mapHeader(response.data || formData));
    } catch (err) {
      setErrorMessage(parseApiError(err));
      setErrorOpen(true);
    }
  };

  const fields = [
    { name: "no", label: "No.", type: "text", disabled: true },
    { name: "requestDate", label: "Request Date", type: "date", disabled: true },
    { name: "machineType", label: "Machine Type", type: "text", disabled: true },
    { name: "machineNo", label: "Machine No.", type: "text", disabled: true },
    { name: "machine", label: "Description", type: "text", disabled: true },
    {
      name: "disposalReason",
      label: "Reason for Disposal",
      type: "textarea",
      disabled: true,
    },
    {
      name: "disposalComment",
      label: "Disposal Comment",
      type: "textarea",
      disabled: true,
    },
    {
      name: "disposalApprovalComment",
      label: "Disposal Approval Comment",
      type: "textarea",
      disabled: true,
    },
    { name: "remarks", label: "Remarks", type: "textarea", disabled: true },
    { name: "status", label: "Status", type: "text", disabled: true },
  ];

  if (!docNo) {
    return (
      <div className="Home">
        <Nav />
        <div className="dash-main settings-full">
          <div className="squote">
            <div className="firsttab px-4">Disposal Request</div>
            <p style={{ padding: 20 }}>No disposal request number was provided.</p>
          </div>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="Home">
      <Nav />
      <div className="dash-main settings-full">
        <div className="squote">
          <div className="firsttab px-4">Disposal Request {docNo}</div>
          <div className="listTable">
            <StandardPageMain
              title={`Disposal Request - ${docNo}`}
              fields={fields}
              initialData={header}
              actions={[]}
              redirectTo="DisposalRequests"
              onBlur={handlePageBlur}
              tableId={DISPOSAL_TABLE_ID}
              PreventEdit={header.status === "Approved"}
              authToken={token}
            />
            <ErrorMessage
              isOpen={errorOpen}
              toggle={() => setErrorOpen(false)}
              caption="Error"
              message={errorMessage}
            />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default DisposalRequest;
